(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const overlay = $('[data-cart-overlay]');
  const drawer = $('[data-cart-drawer]');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);

  function openCart() {
    if (!drawer || !overlay) return;
    drawer.hidden = overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    $('[data-cart-close]', drawer)?.focus();
    refreshCart();
  }
  function closeCart() {
    if (!drawer || !overlay) return;
    drawer.hidden = overlay.hidden = true;
    document.body.style.overflow = '';
    $('[data-cart-open]')?.focus();
  }
  $$('[data-cart-open]').forEach(button => button.addEventListener('click', openCart));
  $('[data-cart-close]')?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && drawer && !drawer.hidden) closeCart(); });

  function textNode(tag, content, className) {
    const element = document.createElement(tag);
    element.textContent = content;
    if (className) element.className = className;
    return element;
  }
  async function refreshCart() {
    if (!drawer) return;
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Could not load cart');
      const cart = await response.json();
      $$('[data-cart-count]').forEach(node => node.textContent = `(${cart.item_count})`);
      $$('[data-header-count]').forEach(node => node.textContent = cart.item_count || '');
      $('[data-cart-shipping]').textContent = cart.total_price >= 4000 ? 'You qualify for free shipping!' : `Free shipping at ${money(4000 - cart.total_price)} more`;
      $('[data-cart-total]').textContent = money(cart.total_price);
      const items = $('[data-cart-items]');
      items.replaceChildren();
      if (!cart.items.length) { items.append(textNode('p', 'Your cart is empty', 'cart-empty')); return; }
      cart.items.forEach(item => {
        const row = document.createElement('article'); row.className = 'cart-line'; row.dataset.key = item.key;
        const image = document.createElement('img'); image.src = item.image || ''; image.alt = item.product_title; image.width = image.height = 80;
        const details = document.createElement('div'); details.append(textNode('strong', item.product_title), textNode('small', item.variant_title === 'Default Title' ? '' : item.variant_title));
        const controls = document.createElement('div'); controls.className = 'cart-line__controls';
        const minus = textNode('button', '−'); minus.type = 'button'; minus.dataset.cartChange = '-1'; minus.setAttribute('aria-label', `Decrease ${item.product_title} quantity`);
        const plus = textNode('button', '+'); plus.type = 'button'; plus.dataset.cartChange = '1'; plus.setAttribute('aria-label', `Increase ${item.product_title} quantity`);
        controls.append(minus, textNode('span', String(item.quantity)), plus); details.append(controls);
        row.append(image, details, textNode('strong', money(item.final_line_price))); items.append(row);
      });
    } catch (error) {
      $('[data-cart-items]').replaceChildren(textNode('p', 'Cart could not load. Use the View cart link to continue.'));
    }
  }
  drawer?.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-change]');
    if (!button) return;
    const row = button.closest('[data-key]');
    const current = Number($('span', $('.cart-line__controls', row)).textContent);
    const quantity = Math.max(0, current + Number(button.dataset.cartChange));
    button.disabled = true;
    try {
      const response = await fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: row.dataset.key, quantity }) });
      if (!response.ok) throw new Error('Could not update cart');
      await refreshCart();
    } catch (error) { window.location.assign('/cart'); }
  });

  $$('[data-product-section]').forEach(section => {
    const main = $('[data-gallery-main]', section);
    $$('[data-gallery-thumb]', section).forEach(button => button.addEventListener('click', () => {
      main.src = button.dataset.full;
      main.alt = $('img', button)?.alt || main.alt;
      $$('[data-gallery-thumb]', section).forEach(other => other.removeAttribute('aria-current'));
      button.setAttribute('aria-current', 'true');
    }));
    const form = $('[data-product-form]', section) || $('form[action*="/cart/add"]', section);
    if (!form) return;
    const quantity = $('input[name="quantity"]', form);
    $('[data-quantity-minus]', form)?.addEventListener('click', () => { quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1)); });
    $('[data-quantity-plus]', form)?.addEventListener('click', () => { quantity.value = String(Math.min(99, Number(quantity.value || 1) + 1)); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const submit = $('button[type="submit"]', form);
      const status = $('[data-form-status]', form);
      const selected = $('input[name="id"]:checked', form);
      if (!selected) { status.textContent = 'Please select a pack.'; return; }
      const data = new FormData(); data.set('id', selected.value); data.set('quantity', String(Math.max(1, Number(quantity?.value || 1))));
      submit.disabled = true; status.textContent = 'Adding to cart…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: data, headers: { 'Accept': 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Could not add this pack to your cart.');
        status.textContent = 'Added to cart.';
        openCart();
      } catch (error) { status.textContent = error.message || 'Could not add to cart. Please try again.'; }
      finally { submit.disabled = false; }
    });
  });
  const reviews = $('[data-review-track]');
  $('[data-review-prev]')?.addEventListener('click', () => reviews.scrollBy({ left: -330, behavior: 'smooth' }));
  $('[data-review-next]')?.addEventListener('click', () => reviews.scrollBy({ left: 330, behavior: 'smooth' }));
})();
